<template>
  <div class='contract-list' v-loading='importLoading'>
      <div class='tableContainer'>
        <el-row>
          <el-col :span="24">
            <el-table
              v-loading='tableLoad'
              :data='TableDatas'
              style='width:100%;height: 310px'
              height="320"
              border
              stripe
              :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
              :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
            >
              <el-table-column label='序号' align='center' width='50px' type='index'
                               :index='(index)=>{return  this.form.rows * (this.form.page - 1) + index + 1;}'>
              </el-table-column>
              <el-table-column prop='codeNumber' label='合同编号' width='100' align='center' />
              <el-table-column prop='contractName' label='合同名称' min-width='120' align='center' />
              <el-table-column prop='typeName' label='合同类型' align='center' />
<!--              <el-table-column prop='companyType' label='签约单位类型' width='100' align='center'>-->
<!--                <template slot-scope='scope'>{{ scope.row.companyType |companyTypeFormat }}</template>-->
<!--              </el-table-column>-->
<!--              <el-table-column prop='companyName' label='签订单位' min-width='150' align='center' />-->
<!--              <el-table-column prop='addPeopleName' label='承办人' align='center'></el-table-column>-->
<!--              <el-table-column prop='createTime' label='签记时间' align='center' width='150'>-->
<!--                <template slot-scope='scope'>-->
<!--                  {{ scope.row.createTime |formatTime }}-->
<!--                </template>-->
<!--              </el-table-column>-->
              <!-- <el-table-column prop="SignatoryTime" label="签约日期" align="center"/> -->
              <el-table-column prop='validityStart' label='有效期' align='center' width='180'>
                <template slot-scope='scope'>
                  {{ scope.row.startDate |validityDady }}--{{ scope.row.endDate |validityDady }}
                </template>
              </el-table-column>
              <el-table-column label='操作' align='center'
                               :min-width="operationWidth==0 ? '230px' : `${operationWidth}px`">
                <template slot-scope='scope'>
                  <div style='align-items:center;' ref='operationWidth' class='caozuo'>
                    <el-button  size='mini' type='primary'
                               @click='changeClick(scope.row)' class='yellow-bg'>详情
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
      <div class='paginationContainer'>
        <el-row>
          <el-col :span="24">
            <el-pagination
              background
              size="small"
              :page-sizes='[10, 20, 30, 40]'
              layout='total, sizes, prev, pager, next, jumper'
              :total='total'
              @size-change='contractSizeChange'
              @current-change='contractCurrentChange'
              :current-page.sync='form.page'
              :page-size='form.rows'
            />
          </el-col>
        </el-row>
      </div>
      <el-dialog :title='dialogTitle' :visible.sync='addflag' width='700px' center
                 @close='dialogClose(4)'>
        <add @addclose='addshow' :dilog-number='dilogNumber' ref='contractAdd' :id='modifyId'></add>
      </el-dialog>
  </div>
</template>
<script>
import add from "@/views/contract/management/list/add"
import {formatTime} from "@/config/mUtils";
import {contractPageList, contractTypeSelectList, contractWarningPage} from "@/service/contract";

export default {
  components: {add},
  data() {
    return {
      companyList:[],
      importLoading: false,
      form: {
        contractName: '',
        type: '',
        contractNumber: '',
        companyName: '',
        createTimes: '',
        createEmpName: '',//承办人
        signatoryName: '',//签约人
        signatoryData: '',//签约日期
        validityTime: '',//有效期开始时间
        status: '',
        page: 1,
        rows: 10,

      },
      total: 0,
      tableLoad: false,
      TableDatas: [],
      modifyId: '',//修改id
      dialogTitle: '',
      // 1 为添加 2 修改
      dilogNumber: 1,
      dialogVisible: false,
      addflag: false,
      operationWidth: 0, //表格操作宽度 动态
    }
  },

  filters: {
    //签记时间
    formatTime(val) {
      return formatTime(val, 'yyyy-mm-dd hh:ii:ss');
    },
    //有效期
    validityDady(val) {
      return formatTime(val, 'yyyy-mm-dd');
    },
    //签约单位类型
    companyTypeFormat(value) {
      switch (value) {
        case 1:
          return '委托商';
        case 2:
          return '公路供应商';
        case 3:
          return '水路供应商';
        case 4:
          return '港口及其他';
      }
    },
  },
  methods: {

    //修改按钮
    changeClick(row) {
      console.log(row)
      // 1 为添加 2 修改
      this.dilogNumber = 2;
      this.dialogTitle = '修改合同';
      this.addflag = true;
      this.modifyId = row.id;
      this.$nextTick(() => {
        this.$refs.contractAdd._modifyDetail();
        this.$refs.contractAdd._getParam();
      });

    },
    async _contractPageList() {
      this.tableLoad = true;
      let {
        createTimes,
        signatoryData,
        validityTime,
      } = this.form;
      let res = await contractWarningPage({
        ...this.form,
        start_createTime: createTimes ? createTimes[0] : createTimes,
        end_createTime: createTimes ? createTimes[1] : createTimes,
        start_signatoryTime: signatoryData ? signatoryData[0] : signatoryData,
        end_signatoryTime: signatoryData ? signatoryData[1] : signatoryData,
        validityStart: validityTime ? validityTime[0] : validityTime,
        validityEnd: validityTime ? validityTime[1] : validityTime,
        TypeId: this.form.type,
      });
      this.tableLoad = false;
      if (res.status !== 0) {
        return this.$message.error(res.message);
      }
      this.TableDatas = res.data.records;
      this.total = res.data.total;
      this.tableWidth();
    },

    contractSizeChange(row) {
      this.form.rows = row;
      this._contractPageList();
    },
    contractCurrentChange(page) {
      this.form.page = page;
      this._contractPageList();
    },
    dialogClose(flag) {
      switch (flag) {
        case 4:
          // this.addflag = false
          this.$refs.contractAdd.dialogClose();
          break;
      }
    },
    addshow(val) {
      this.addflag = val;
      this._contractPageList();
    },
    async _contractTypeSelectList() {
      let res = await contractTypeSelectList({ contractTypeName: '' });
      if (res.status !== 0) return this.$message.error(res.message);
      this.contactTypeList = res.data.map((item) => {
        return {
          typeName: item.contract_name,
          typeId: item.id,
        };
      });
    },
  }
}
</script>

<style scoped lang="scss">
.paginationContainer{
  text-align: center;
  overflow-x: auto;
  white-space: nowrap;
}

.el-pagination {
  display: inline-block !important; /* 使用 !important 防止被覆盖 */
  margin: 0 10px;
}

</style>
